import { UseMutationOptions } from "@tanstack/react-query";
import { updateConnectedAccount } from "services/api/connected-account-api.service";
import { QueryKey } from "common/enums/query-key";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "services/services";
import { AxiosError } from "axios";
import { BackendError } from "common/types/errors/backendError";

export default function useUpdateConnectedAccount(
  options?: Omit<UseMutationOptions<void, AxiosError<BackendError>, void, unknown>, 'mutationFn'>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateConnectedAccount,
    mutationKey: [QueryKey.ConnectedAccount],
    onError: (e) => {
      notification.error('Error while updating connected account');
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.ConnectedAccount] });
    },
    ...options,
  });
}